import apiClient from './client'
import type { TrackingFilters, TrackingResponse } from '../types'

function buildParams(filters: TrackingFilters): URLSearchParams {
  const params = new URLSearchParams()

  if (filters.page) params.set('page', String(filters.page))
  if (filters.per_page) params.set('per_page', String(filters.per_page))
  if (filters.sort) params.set('sort', filters.sort)
  if (filters.order) params.set('order', filters.order)
  if (filters.q) params.set('q', filters.q)

  return params
}

export async function getTracking(filters: TrackingFilters = {}): Promise<TrackingResponse> {
  const params = buildParams(filters)
  const response = await apiClient.get<TrackingResponse>(`/tracking?${params}`)
  return response.data
}

export async function addTracking(
  releaseId: number,
  data: { notes?: string; target_buy_price?: number } = {}
): Promise<{ success: boolean }> {
  const response = await apiClient.post(`/tracking/${releaseId}`, data)
  return response.data
}

export async function removeTracking(releaseId: number): Promise<{ success: boolean }> {
  const response = await apiClient.delete(`/tracking/${releaseId}`)
  return response.data
}

export async function updateTracking(
  releaseId: number,
  data: { notes?: string; target_buy_price?: number }
): Promise<{ success: boolean }> {
  const response = await apiClient.put(`/tracking/${releaseId}`, data)
  return response.data
}

export async function checkTrackingStatus(
  releaseId: number
): Promise<{ success: boolean; is_tracked: boolean }> {
  const response = await apiClient.get(`/tracking/${releaseId}/status`)
  return response.data
}

export async function triggerTrackingAlerts(): Promise<{ success: boolean; sent?: number; error?: string }> {
  const response = await apiClient.post('/tracking/notify')
  return response.data
}

export async function sendTestTelegramMessage(): Promise<{ success: boolean; error?: string }> {
  const response = await apiClient.post('/tracking/notify/test')
  return response.data
}

export async function initiateTelegramConnect(): Promise<{ success: boolean; botUrl?: string; token?: string; botUsername?: string; error?: string }> {
  const response = await apiClient.get('/auth/telegram/connect')
  return response.data
}

export async function connectTelegramWidget(data: {
  id: number
  first_name?: string
  last_name?: string
  username?: string
  photo_url?: string
  auth_date: number
  hash: string
}): Promise<{ success: boolean; error?: string }> {
  const response = await apiClient.post('/auth/telegram/widget-connect', data)
  return response.data
}

export async function disconnectTelegram(): Promise<{ success: boolean }> {
  const response = await apiClient.delete('/users/me/telegram')
  return response.data
}

export interface UserProfile {
  id: number
  email: string
  role: string
  discogs_username: string | null
  telegram_chat_id: string | null
  onboarding_completed_at: string | null
}

export async function getCurrentUser(): Promise<{ success: boolean; user: UserProfile }> {
  const response = await apiClient.get('/users/me')
  return response.data
}

export async function completeOnboarding(): Promise<{ success: boolean }> {
  const response = await apiClient.post('/users/me/onboarding-complete')
  return response.data
}
